<div class="heading py-5">
  <h1 class="bold font-curve-large">Rating</h1>
  <app-dependency-link></app-dependency-link>
</div>

<section>
  <app-ngb-rating-demo></app-ngb-rating-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplate"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>
